
import { Client } from "../../types";
import { Info } from "lucide-react";
// Note: Internal notes are not typically part of enrichment, so no FieldIndicator is needed here.

interface InternalNotesSectionProps {
  client: Client;
}

export const InternalNotesSection: React.FC<InternalNotesSectionProps> = ({ client }) => {
  if (!client.notes) return null;

  return (
    <div className="space-y-2 pt-4">
      <h3 className="text-lg font-semibold text-gray-800 dark:text-slate-200 border-b pb-2 flex items-center">
        <Info className="w-5 h-5 mr-2 text-invenio-primary" />
        Internal Notes
      </h3>
      <p className="text-sm whitespace-pre-wrap">{client.notes}</p>
    </div>
  );
};
